<template>
  <FaIcon :icon="['fas', PERSON_DEFAULT_ICON]" />
</template>

<script setup lang="ts">
import { PERSON_DEFAULT_ICON } from '@/constants/person';
</script>
